import * as React from "react"
import HomeVideo from "../assets/PFB_Transforming_Hero_COMPRESS_3.mp4"
import Poster from "../images/home-video-poster.jpg"

export default function Videohero() {
  return (
    <div className="relative w-full h-full">
      <video
        className="object-cover inset-0 absolute w-full h-full z-0"
        autoPlay
        playsInline
        loop
        muted
        poster={Poster}
      >
        <source src={HomeVideo} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-radial-gradient z-10 pointer-events-none"></div>
    </div>
  )
}
